import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class DiscountCodeModel extends BaseAPIModel {
    fields() {
        return {
            id: { primaryKey: true, readOnly: true }
        };
    }

    // TODO: handle limit/offset rules
    static listUrl({ organizationId, eventId, isCreateOrUpdate, isDelete }) {
        if (isCreateOrUpdate) {
            if (!organizationId) throw new ArgumentError(`[Model][DiscountCode][cu]: missing organization and (optionnal) event ids (organizationId: mandatory)`);
            if (eventId) return `/ticket/organizations/${organizationId}/events/${eventId}/discount-codes-bulk`;
            return `/ticket/organizations/${organizationId}/discount-codes-bulk`;
        } else if (isDelete) {
            if (!organizationId) throw new ArgumentError(`[Model][DiscountCode][delete]: missing organization and (optionnal) event ids (organizationId: mandatory)`);
            if (eventId) return `/ticket/organizations/${organizationId}/events/${eventId}/discount-codes/bulk`;
            return `/ticket/organizations/${organizationId}/discount-codes/bulk`;
        } else {
            if (!organizationId) throw new ArgumentError(`[Model][DiscountCode][getAll]: missing organization and (optionnal) event ids (organizationId: mandatory)`);
            if (eventId) return `/ticket/organizations/${organizationId}/events/${eventId}/discount-codes`;
            return `/ticket/organizations/${organizationId}/discount-codes`;
        }
    }

    //Overwride save  to use the same endpoint for post and patch
    save(params = {}, query = {}) {
        const data = this.toAPI();
        const newParams = {
            ...this.__params,
            ...params,
            id: this.pk
        };

        delete newParams.metadata;

        let promise = null;
        const url = this.constructor.getListUrl(newParams);
        if (this.pk) {
            promise = this.constructor.fetcher.patch(url, { ...params, data });
        } else {
            promise = this.constructor.fetcher.post(url, { ...params, data });
        }

        return promise.then(result => {
            const { response } = result;
            this._updateInPlace(response instanceof Object ? { ...response } : response);

            this.constructor.fetcher.clear_cache(this.constructor.listUrl(newParams));
            if (this.pk) {
                this.constructor.fetcher.clear_cache(this.constructor.getItemUrl({ ...newParams, id: this.pk }));
            }
            return result;
        });
    }

    static performToggleActivation(orgaId, eventId, discountCodes, enabled) {
        if (discountCodes.length === 1) {
            const discountCode = discountCodes[0];
            return new DiscountCodeModel(discountCode).save({ id: discountCode.id, enabled, organizationId: orgaId, eventId, isCreateOrUpdate: true });
        } else {
            const data = {
                type: 'async_bulk_update',
                config: {
                    pks: discountCodes.map(({ id }) => id),
                    enabled
                }
            };
            return fetcher.post(`/ticket/organizations/${orgaId}/events/${eventId}/discount-codes/actions`, { data });
        }
    }

    static performDelete({ orgaId, eventId, discountCodes }) {
        if (discountCodes.length === 1) {
            const discountCode = discountCodes[0];
            return new DiscountCodeModel(discountCode).destroy({ id: discountCode.id, organizationId: orgaId, eventId });
        } else {
            const data = {
                type: 'async_bulk_delete',
                config: {
                    pks: discountCodes.map(({ id }) => id)
                }
            };
            return fetcher.post(`/ticket/organizations/${orgaId}/events/${eventId}/discount-codes/actions`, { data: data });
        }
    }

    static performBulkCreate(orgaId, eventId, config) {
        const data = {
            type: 'async_bulk_create',
            config
        };
        return fetcher.post(`/ticket/organizations/${orgaId}/events/${eventId}/discount-codes/actions`, { data: data });
    }
}
